/*
 * operations Actions
 *
 * @version 1.0.0
 * @author Stefano Servodidio
 * @since 02-Jul-2024
 */

import { createRequestTypes, createAction, MakeRequest } from './index'

export const actionTypes = {
  DO_FETCH_OPERATION_DETAILS: '@@operations/fetch_operation_details',
  DO_FETCH_OPERATIONS: '@@operations/fetch_operations',
  DO_FETCH_PARAMETERS: '@@operations/fetch_parameters',
  DO_RESET_OPERATIONS: '@@operations/reset_operations',
  DO_FETCH_OPERATION_ACTIONS: '@@operations/fetch_operation_actions',
  DO_FETCH_PAYMENT_METHODS_LIST: '@@operations/fetch_payment_methods_list',
  DO_GET_OPERATION_TERMINAL: '@@operations/get_operation_terminal',
  DO_EXPORT_OPERATIONS: '@@operations/export_operations',
  DO_OPERATION_CAPTURE_REFUND: '@@operations/operation_capture_refund',
  DO_RESET_ACTIONS_MENU: '@@operations/reset_actions_menu',
  DO_SET_TIME_STAMP_RESEARCH: '@@operations/set_time_stamp_research',
  // @generator action:type
  ...createRequestTypes('@@operations', 'DO_GET_OPERATION_DETAILS'),
  ...createRequestTypes('@@operations', 'DO_GET_OPERATIONS'),
  ...createRequestTypes('@@operations', 'DO_GET_PARAMETERS'),
  ...createRequestTypes('@@operations', 'GET_OPERATION_ACTIONS'),
  ...createRequestTypes('@@operations', 'GET_PAYMENT_METHODS_LIST'),
  ...createRequestTypes('@@operations', 'RETRIVE_OPERATION_TERMINAL'),
  ...createRequestTypes('@@operations', 'RETRIVE_OPERATIONS_EXPORT_FILE'),
  ...createRequestTypes('@@operations', 'OPERATION_CAPTURE'),
  ...createRequestTypes('@@operations', 'OPERATION_REFUND'),
  ...createRequestTypes('@@operations', 'OPERATION_CANCEL'),
  ...createRequestTypes('@@operations', 'OPERATION_INCREMENTAL')
  // @generator action:type:request
}

// ------------------------------------
// Actions
// ------------------------------------

// @generator action:request
/** @action request
 * * Insert a description
 * @name operationIncremental
 * @return {object} - The action object
 */
export const operationIncremental = new MakeRequest('operations', 'operation_incremental')
/** @action request
 * * Insert a description
 * @name operationCancel
 * @return {object} - The action object
 */
export const operationCancel = new MakeRequest('operations', 'operation_cancel')
/** @action request
 * * Insert a description
 * @name operationRefund
 * @return {object} - The action object
 */
export const operationRefund = new MakeRequest('operations', 'operation_refund')
/** @action request
 * * Insert a description
 * @name operationCapture
 * @return {object} - The action object
 */
export const operationCapture = new MakeRequest('operations', 'operation_capture')
/** @action request
 * * Insert a description
 * @name retriveOperationsExportFile
 * @return {object} - The action object
 */
export const retriveOperationsExportFile = new MakeRequest('operations', 'retrive_operations_export_file')
/** @action request
 * * Insert a description
 * @name retriveOperationTerminal
 * @return {object} - The action object
 */
export const retriveOperationTerminal = new MakeRequest('operations', 'retrive_operation_terminal')
/** @action request
 * * Insert a description
 * @name getPaymentMethodsList
 * @return {object} - The action object
 */
export const getPaymentMethodsList = new MakeRequest('operations', 'get_payment_methods_list')
/** @action request
 * * Insert a description
 * @name getOperationActions
 * @return {object} - The action object
 */
export const getOperationActions = new MakeRequest('operations', 'get_operation_actions')
/** @action request
 * * Insert a description
 * @name doGetParameters
 * @return {object} - The action object
 */
export const doGetParameters = new MakeRequest('operations', 'do_get_parameters')
/** @action request
 * * Insert a description
 * @name doGetOperations
 * @return {object} - The action object
 */
export const doGetOperations = new MakeRequest('operations', 'do_get_operations')
/** @action request
 * * Insert a description
 * @name doGetOperationDetails
 * @return {object} - The action object
 */
export const doGetOperationDetails = new MakeRequest('operations', 'do_get_operation_details')

// @generator action
/** @action
 * * Insert a description
 * @name SetTimeStampResearch
 * @return {object} - The payload object
 */
export const doSetTimeStampResearch = (payload) => createAction(actionTypes.DO_SET_TIME_STAMP_RESEARCH, { payload })
/** @action
 * * Insert a description
 * @name ResetActionsMenu
 * @return {object} - The payload object
 */
export const doResetActionsMenu = (payload) => createAction(actionTypes.DO_RESET_ACTIONS_MENU, { payload })
/** @action
 * * Insert a description
 * @name OperationCaptureRefund
 * @return {object} - The payload object
 */
export const doOperationCaptureRefund = (payload) => createAction(actionTypes.DO_OPERATION_CAPTURE_REFUND, { payload })
/** @action
 * * Insert a description
 * @name ExportOperations
 * @return {object} - The payload object
 */
export const doExportOperations = (payload) => createAction(actionTypes.DO_EXPORT_OPERATIONS, { payload })
/** @action
 * * Insert a description
 * @name GetOperationTerminal
 * @return {object} - The payload object
 */
export const doGetOperationTerminal = (payload) => createAction(actionTypes.DO_GET_OPERATION_TERMINAL, { payload })
/** @action
 * * Insert a description
 * @name FetchPaymentMethodsList
 * @return {object} - The payload object
 */
export const doFetchPaymentMethodsList = (payload) =>
  createAction(actionTypes.DO_FETCH_PAYMENT_METHODS_LIST, { payload })
/** @action
 * * Insert a description
 * @name FetchOperationActions
 * @return {object} - The payload object
 */
export const doFetchOperationActions = (payload) => createAction(actionTypes.DO_FETCH_OPERATION_ACTIONS, { payload })
/** @action
 * * Insert a description
 * @name doFetchParameters
 * @return {object} - The action object
 */
export const doFetchParameters = (payload) => createAction(actionTypes.DO_FETCH_PARAMETERS, { payload })
/** @action
 * * Insert a description
 * @name doFetchOperations
 * @return {object} - The action object
 */
export const doFetchOperations = (payload) => createAction(actionTypes.DO_FETCH_OPERATIONS, { payload })
/** @action
 * * Insert a description
 * @name doFetchOperationDetails
 * @return {object} - The action object
 */
export const doFetchOperationDetails = (payload) => createAction(actionTypes.DO_FETCH_OPERATION_DETAILS, { payload })
/** @action
 * * Insert a description
 * @name doResetOperations
 * @return {object} - The action object
 */
export const doResetOperations = (payload) => createAction(actionTypes.DO_RESET_OPERATIONS, { payload })
